<template>
  <div>
    <input
      type="tel"
      ref="input"
      placeholder="XXX-XXX-XXXX"
      @input="handleInput"
      :value="value"
      required
    />
  </div>
</template>

<script>
import Cleave from 'cleave.js'
export default {
  data () {
    return {
      cleave: null
    }
  },
  computed: {
    value () {
      return this.$store.state.userData[this.dataKey]
    }
  },
  methods: {
    handleInput (event) {
      const value = this.cleave.getRawValue()
      if (value.length > 10) {
        this.$emit('input', {
          value: this.cleave.getRawValue().slice(0, 10)
        })
      } else {
        this.$emit('input', { value: this.cleave.getRawValue() })
      }
    }
  },
  mounted () {
    this.cleave = new Cleave(this.$refs.input, {
      blocks: [3, 3, 4],
      delimiter: '-'
    })
  },
  props: ['options', 'data-key']
}
</script>
